module.exports = __webpack_public_path__ + "img/notes.5a49fc6d.svg";